import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { InvitedUser, User } from '@/types/users'

interface UserInitialState {
  token?: string
  invitedUsers: InvitedUser[]
  userData?: User
  users: User[],
}

const initialState: UserInitialState = {
  token: undefined,
  invitedUsers: [],
  userData: undefined,
  users: [],
}

const setUserToken = (
  state: UserInitialState = initialState,
  action: PayloadAction<string>
) => {
  return {
    ...state,
    token: action.payload
  }
}

const setUserDetails = (
  state: UserInitialState = initialState,
  action: PayloadAction<User>
) => {
  return {
    ...state,
    userData: action.payload
  }
}

const setUsers = (
  state: UserInitialState = initialState,
  action: PayloadAction<User[]>
) => {
  return {
    ...state,
    users: action.payload
  }
}

const setInvitedUsers = (
  state: UserInitialState = initialState,
  action: PayloadAction<InvitedUser[]>
) => {
  return {
    ...state,
    invitedUsers: action.payload
  }
}

const logoutUser = () => {
  return {
    token: undefined,
    userData: undefined,
    users: [],
    invitedUsers: []
  }
}

const userSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUserToken,
    setUserDetails,
    logoutUser,
    setUsers,
    setInvitedUsers
  }
})

export const userReducer = userSlice.reducer
export const userActions = userSlice.actions
